import { FilterProp } from 'frontend/types'
import { getKebabCaseOptionId } from 'frontend/utils/helpers'
import styles from './FilterDropdownItem.module.css'
import classnames from 'classnames'

interface Props {
  isSelected: boolean
  option: FilterProp
  onOptionSelect: (option: FilterProp) => void
  isOpen: boolean
  index: number
  isSingleChoice: boolean
  isOnMobile: boolean
}

const FilterDropdownItem = ({
  isSelected,
  option,
  onOptionSelect,
  index,
  isOpen,
  isSingleChoice,
  isOnMobile,
}: Props) => {
  const identifier = `${option.value}${
    isSingleChoice ? '-radio' : '-checkbox'
  }${isOnMobile ? '-mobile' : '-desktop'}`
  const name = isOnMobile ? 'radio-options-mobile' : 'radio-options'

  return (
    <li
      className={classnames(
        styles.dropdownItem,
        isSingleChoice ? styles.radioButton : styles.checkBox,
      )}
    >
      <input
        id={getKebabCaseOptionId(index, identifier)}
        name={isSingleChoice ? name : getKebabCaseOptionId(index, identifier)}
        value={option.value as string}
        type={isSingleChoice ? 'radio' : 'checkbox'}
        checked={isSelected}
        onChange={() => onOptionSelect(option)}
        aria-disabled={!option.available}
        disabled={!option.available && !isSelected}
        tabIndex={isOpen ? 0 : -1}
      />
      <label
        htmlFor={getKebabCaseOptionId(index, identifier)}
        data-testid="filter-dropdown-option"
      >
        {option.label}{' '}
        {option.count && option.count > 0 && ` (${option.count})`}
      </label>
    </li>
  )
}

export default FilterDropdownItem
